import { delay, Glow, iconClassName, styles, svgProps } from '@/components/service-showcase/icons/shared';
import type { IServiceShowcaseSvgIconProps } from '@/components/service-showcase/icons/type';

// Concentric circles centred at (190, 110) — r=90/60/34 fits the 380×220 viewBox

export default function ConcentricTargetIcon(props: IServiceShowcaseSvgIconProps) {
  const { active = true, className, ...rest } = props;

  return (
    <svg {...svgProps} {...rest} className={iconClassName(active, className)}>
      <Glow cx={190} cy={110} r={32} opacity={0.24} />

      {/* Static concentric rings */}
      <circle cx='190' cy='110' r='90' stroke='currentColor' strokeOpacity='0.18' className={styles.ring} style={delay('0s')} />
      <circle cx='190' cy='110' r='60' stroke='currentColor' strokeOpacity='0.22' className={styles.ring} style={delay('0.2s')} />
      <circle cx='190' cy='110' r='34' stroke='currentColor' strokeOpacity='0.55' className={styles.ring} style={delay('0.4s')} />

      {/* Outer orbit group — 2 faint nodes spinning slowly around r=90 */}
      <g className={styles.orbit} style={{ transformOrigin: '190px 110px' }}>
        <circle cx='280' cy='110' r='4' fill='currentColor' fillOpacity='0.45' />
        <circle cx='190' cy='20' r='3.5' fill='currentColor' fillOpacity='0.32' />
      </g>

      {/* Inner orbit group — 1 bright node counter-rotating around r=60 */}
      <g className={styles.orbitInner} style={{ transformOrigin: '190px 110px' }}>
        <circle cx='250' cy='110' r='4.5' fill='currentColor' fillOpacity='0.9' />
      </g>

      {/* Expanding pulse ring at centre */}
      <circle
        cx='190' cy='110' r='14'
        stroke='currentColor' strokeOpacity='0.45' fill='none'
        className={styles.sourcePulse}
        style={{ transformBox: 'fill-box', transformOrigin: 'center' }}
      />

      {/* Centre core dot */}
      <circle cx='190' cy='110' r='8' fill='currentColor' fillOpacity='0.9' className={styles.core} />

      <text x='201' y='107' fill='currentColor' fillOpacity='0.38' fontSize='8' fontFamily='monospace' letterSpacing='0.1em'>CORE</text>
    </svg>
  );
}
